import {
  Questionnaire,
  QuestionnaireStep,
} from 'APIs/letrusAPI/questionnaire/types';
import {useCallback, useRef, useState} from 'react';

function useQuestionnaireNavigation(questionnaireData?: Questionnaire) {
  const [currentStep, setCurrentStep] = useState<QuestionnaireStep>();

  const stableRef = useRef({
    questionnaire: questionnaireData,
    currentStep,
  });

  stableRef.current.questionnaire = questionnaireData;
  stableRef.current.currentStep = currentStep;

  const nextStep = useCallback(() => {
    const {questionnaire, currentStep} = stableRef.current;

    if (!questionnaire) return;

    const currentStepIndex = questionnaire.steps.indexOf(
      currentStep || questionnaire?.steps[0],
    );

    const nextStepIndex = currentStepIndex + 1;
    if (nextStepIndex < questionnaire.steps.length) {
      setCurrentStep(questionnaire.steps[nextStepIndex]);
    }
  }, []);

  const previousStep = useCallback(() => {
    const {questionnaire, currentStep} = stableRef.current;

    if (!currentStep || !questionnaire) return;

    const currentStepIndex = questionnaire.steps.indexOf(currentStep);
    const previousStepIndex = currentStepIndex - 1;

    if (previousStepIndex >= 0) {
      setCurrentStep(questionnaire?.steps[previousStepIndex]);
    }
  }, []);

  const goToStepById = useCallback((stepId: number) => {
    const {questionnaire} = stableRef.current;

    if (!questionnaire) return;

    const step = questionnaire?.steps?.find((step) => step?.id === stepId);

    if (step) {
      setCurrentStep(step);
    }
  }, []);

  const goToStepByOrder = useCallback((order: number) => {
    const {questionnaire} = stableRef.current;

    if (!questionnaire) return;

    const step = questionnaire?.steps?.find((step) => step?.order === order);

    if (step) {
      setCurrentStep(step);
    }
  }, []);

  return {
    ...questionnaireData,
    nextStep,
    previousStep,
    goToStepById,
    goToStepByOrder,
    length: questionnaireData?.steps?.length || 1,
    currentStep: currentStep || questionnaireData?.steps[0],
    isOnLastStep: currentStep?.order === questionnaireData?.steps.length,
  };
}

export default useQuestionnaireNavigation;
